import { render, staticRenderFns } from "./TournamentStandingsHeader.vue?vue&type=template&id=49945ed5&"
import script from "./TournamentStandingsHeader.vue?vue&type=script&lang=js&"
export * from "./TournamentStandingsHeader.vue?vue&type=script&lang=js&"
import style0 from "./TournamentStandingsHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49945ed5')) {
      api.createRecord('49945ed5', component.options)
    } else {
      api.reload('49945ed5', component.options)
    }
    module.hot.accept("./TournamentStandingsHeader.vue?vue&type=template&id=49945ed5&", function () {
      api.rerender('49945ed5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentStandingsHeader.vue"
export default component.exports